module.exports = __webpack_public_path__ + "img/doc-banner.d71b2317.png";